import { FC } from 'react';

import Page from '@/components/Page.tsx';

const HomePage: FC = () => {
    // eslint-disable-next-line i18next/no-literal-string
    return <Page fullScreen>Home Page</Page>;
};

export default HomePage;
